import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  // static element = this.targets.element;

  connect() {
    // Guard against double-init: Stimulus re-connect on Turbo navigations
    // or a page fragment that renders the same <select> twice would leave
    // two overlapping widgets on the field, which reads as "the value
    // appears twice."
    if (this.element.tomselect) return;

    // The remove_button plugin is only useful when the user can delete
    // selections independently — i.e. multi-select. On a single-select
    // it renders a stray "Value ×" chip below the dropdown that
    // reads as a duplicate of the current value. Detect the mode
    // from the underlying <select> so the same controller drives both
    // shapes without callers having to configure it.
    const isMulti = this.element.multiple;
    this.ts = new TomSelect(
      this.element,
      {
        maxOptions: 100,
        create: false,
        plugins: isMulti ? ["remove_button"] : [],
        allowEmptyOption: !isMulti,
      }
    );
  }

  disconnect() {
    // Free the widget on Turbo navigations so a follow-up connect() can
    // re-instantiate cleanly. Without this the double-init guard above
    // holds forever and the field freezes on the next visit.
    if (this.ts) {
      this.ts.destroy();
      this.ts = null;
    }
  }
}
